import React from 'react'
import type { UseSeatUtilizationResult } from '@hooks/dashboard/useSeatUtilization'
import { OperationsDonutCard } from '../OperationsDonutCard.component'

type SeatUtilizationCardProps = {
  titleHref: string
  metrics: UseSeatUtilizationResult['cardMetrics']
  chartData: UseSeatUtilizationResult['donutSlices']
  loading: boolean
  hasPayload: boolean
}

export function SeatUtilizationCard({
  titleHref,
  metrics,
  chartData,
  loading,
  hasPayload,
}: SeatUtilizationCardProps): React.ReactElement {
  return (
    <OperationsDonutCard
      title="Seat utilization"
      titleHref={titleHref}
      metrics={metrics}
      chartData={chartData}
      loading={loading}
      hasPayload={hasPayload}
    />
  )
}
